export const SET_MAKES = 'SET_MAKES'
export const SET_MAKE = 'SET_MAKE'
export const ADD_MAKE = 'ADD_MAKE'
export const CANCEL_NEWMAKE = 'CANCEL_NEWMAKE'
export const SET_MAKEACTIVATION = 'SET_MAKEACTIVATION'



// WEBPACK FOOTER //
// ./src/store/modules/make/types.js